import axios from 'axios';

import { authHeader } from '@H';
import { authService } from '@S';

export default {
  getProductList: () =>
    axios({
      method: 'GET',
      headers: authHeader(),
      url: `${process.env.API_URL}/bunk/omc/product/${authService.currentOMC}`,
    }),
  getTankList: () =>
    axios({
      method: 'GET',
      headers: authHeader(1),
      url: `${process.env.API_URL}/bunk/associate-tanks/`,
    }),
  getTank: (id) =>
    axios({
      method: 'GET',
      headers: authHeader(1),
      url: `${process.env.API_URL}/bunk/associate-tanks/?tank_id=${id}`,
    }),
};
